import React from "react";
import PatientListView from "../../../../pages/Dashboard/PatientListView/PatientListGridContainer/PatientListView";

function PatientList() {
  return (
    <div className="pl-content">
      <div className="pl-content-wrapper">
            <PatientListView/>
      </div>
    </div>
  );
}

export default PatientList;
